import { Splide } from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    const that  = this;
    const debug = false;

    // Init header
    const header          = document.getElementById('main-header');
    const sections        = $('[data-bg-color]');
    const teamBlockExists = $('.team-wrap').length > 0 ? true : false;

    this.initHeader(header);
    this.changeBg(sections);
    this.appear(debug);

    // Init smooth section scrolling
    this.initHashLinks();

    // Init hero block
    if ($('.hero-block').length > 0) {
      this.initHeroBlock();

      if ($('.hero-slide[data-id=1]').data('slide-theme') === 'light') {
        $('.main-header').addClass('main-header--light')
        $('.hero-block').addClass('hero-block--light')
      }
    }

    // Init entry overlay (deprecated)
    if ($('.entry-overlay').length > 0) {
      setTimeout(function() {
        $('.hero-block').removeClass('invisible');
        $('#main-header').addClass('fadeInDown');
        $('.entry-overlay').addClass('animated fadeOut');

        setTimeout(function() {
          $('.entry-overlay').addClass('hide');
        }, 600);
      }, 1500);
    }

    // Init partners slider
    if ($('.partners-block').length > 0) {
      this.initPartnersSlider();
    }

    // Init portfolio block.
    if ($('.portfolio-block').length > 0) {
      this.initPortfolio();
    }

    // Listen for scroll and make header shrink if scrolled
    window.onscroll = function() {
      that.initHeroScroll();
      that.initHeader(header);
      that.changeBg(sections);
      that.appear(debug);

      if (teamBlockExists) {
        that.initTeamBlock();
      }
    };

    // Listen for mobile menu toggle click.
    this.initMobileMenu(header);

    // Set dynamic CSS variables.
    const setVariables = (resize) => {
      const doc   = document.documentElement;
      const arrow = document.querySelector('.footer__arrow--desktop');

      if (!resize) {
        doc.style.setProperty('--window-height-init', `${window.innerHeight}px`);
      }

      doc.style.setProperty('--window-height', `${window.innerHeight}px`);

      if (arrow) {
        doc.style.setProperty('--arrow-width', `${document.querySelector('.footer__arrow--desktop').offsetWidth}px`)
      }
    }

    window.addEventListener('resize', setVariables(true))

    setVariables(false);

    setTimeout(function() {
      setVariables(false);
    }, 100);
  },
  initHeader(header) {
    if(window.pageYOffset > 10) {
      header.classList.add('shrinked');
    } else {
      header.classList.remove('shrinked');
    }
  },
  initMobileMenu(header) {
    const mobileNavButton = document.getElementById('mobile-nav-button');

    mobileNavButton.addEventListener('click', () => {
      const mobileDropdownMenuEl = document.getElementById('mobile-menu-dropdown');

      if (header.classList.contains('menu-moving')) {
        return;
      }

      if (mobileDropdownMenuEl.classList.contains('fadeInDown')) {
        mobileDropdownMenuEl.classList.remove('fadeInDown');
        mobileDropdownMenuEl.classList.add('fadeOutUp');
        mobileNavButton.classList.remove('active');
        header.classList.remove('menu-opened');
        header.classList.add('menu-moving');

        setTimeout( () => {
          mobileDropdownMenuEl.classList.add('d-none');
          header.classList.remove('menu-moving');
        }, 600);
      } else {
        mobileDropdownMenuEl.classList.remove('d-none', 'fadeOutUp');
        mobileDropdownMenuEl.classList.add('fadeInDown');
        mobileNavButton.classList.add('active');
        header.classList.add('menu-opened', 'menu-moving');

        setTimeout( () => {
          header.classList.remove('menu-moving');
        }, 600);
      }
    });
  },
  initHeroBlock() {
    const intervalTime = 6000;

    let sliderInterval = window.setInterval(function() {
      if ($('.hero-block-navigation__item.active').next('.hero-block-navigation__item').length > 0) {
        $('.hero-block-navigation__item.active').next('.hero-block-navigation__item').click();
      } else {
        $('.hero-block-navigation').children().first().click();
      }
    }, intervalTime);

    $('.hero-block-navigation__item').on('click', function(e) {
      e.preventDefault();

      clearInterval(sliderInterval);

      if (!$('.hero-block').hasClass('transitioning')) {
        const slideID    = $(this).data('slide-id'),
              slideTheme = $(this).data('slide-theme');

        const $activeSlide = $('.hero-block').find('.hero-slide.active');
        $activeSlide.removeClass('fadeIn').addClass('fadeOut');

        $('.hero-block').addClass('transitioning');

        setTimeout(function() {
          $activeSlide.removeClass('active');
          $('.hero-block').find(`[data-id='${slideID}']`).removeClass('fadeOut').addClass('active fadeIn');

          if (slideTheme === 'light') {
            $('.main-header').addClass('main-header--light');
            $('.hero-block').addClass('hero-block--light');
          } else {
            $('.main-header').removeClass('main-header--light');
            $('.hero-block').removeClass('hero-block--light');
          }
        }, 400);

        setTimeout(function() {
          $('.hero-block').removeClass('transitioning');
        }, 600);

        $('.hero-block-navigation__item').removeClass('active');
        $(this).addClass('active');

        sliderInterval = window.setInterval(function() {
          if ($('.hero-block-navigation__item.active').next('.hero-block-navigation__item').length > 0) {
            $('.hero-block-navigation__item.active').next('.hero-block-navigation__item').click();
          } else {
            $('.hero-block-navigation').children().first().click();
          }
        }, intervalTime);
      }
    });
  },
  initHeroScroll() {
    const windowBottom = window.scrollY + window.innerHeight;

    if (windowBottom >= $('.hero-block').outerHeight() && window.scrollY <= $('.hero-block').outerHeight() + $('.hero-block-spacer').outerHeight()) {
      $('.hero-slide, .hero-block-navigation').addClass('fixed');
    } else {
      $('.hero-slide, .hero-block-navigation').removeClass('fixed');
    }
  },
  changeBg(sections) {
    const windowBottom = window.scrollY + window.innerHeight;

    let newBgColor,
        $currentSection = false;

    $(sections).each( function() {
      if (windowBottom >= $(this).offset().top + window.innerHeight * 0.5) {
        newBgColor = $(this).data('bg-color');
        $currentSection = $(this);
      } else {
        return false;
      }
    });

    if (!newBgColor) {
      newBgColor = $(sections).first().data('bg-color');
    }

    if ($currentSection && ($currentSection.hasClass('vc-talk-block') || $currentSection.hasClass('our-approach-block'))) {
      $('.team-photo-block__bg').css('background-color', newBgColor);
    }

    $('body').css('background-color', newBgColor);
  },
  appear(debug) {
    const windowBottom = window.scrollY + window.innerHeight;

    $('[data-animation]').each(function() {
        const element_top = $(this).offset().top;

        let offset = window.innerHeight * 0.5;

        if ($(this).data('animation-offset')) {
          offset = window.innerHeight * $(this).data('animation-offset');
        }

        if ((element_top + offset) < windowBottom) {
            $(this).addClass('appear-show');

            if ($(this).data('animation')) {
              $(this).addClass('animated ' + $(this).data('animation'));
            }

            if ($(this).data('animation-delay')) {
              $(this).css('animation-delay', $(this).data('animation-delay'));
            }
        } else {
          if (debug) {
            $(this).removeClass('appear-show animated fadeIn fadeInUp fadeInUpSmall')
          }
        }
    });
  },
  initHashLinks() {
    $('#main-header a, .mobile-main-menu a').on('click', function() {
      const hash = this.hash;

      if (hash !== '') {
        $('#mobile-nav-button').click();

        if ($(hash).length > 0) {
          $('html, body').animate({
            scrollTop: $(hash).offset().top - $('#main-header').outerHeight() + 1,
          }, 1000);
        }
      }
    });
  },
  initTeamBlock() {
    const windowBottom = window.scrollY + window.innerHeight,
          $teamWrap    = $('.team-wrap');

    if (windowBottom >= $teamWrap.offset().top + window.innerHeight * 0.5 && windowBottom <= $('.team-wrap-block').offset().top + $('.team-wrap-block').outerHeight() + $('.team-photo-block__inner').outerHeight()) {
      $('.team-photo-block__inner').addClass('fixed');

      if ($teamWrap.hasClass('not-initialized')) {
        $('.team-photo-block__inner').addClass('animated fadeIn');
      }

      const insideBlockScrollFromTop     = windowBottom - $('.team-photo-block').offset().top,
            teamBlockFixedHeight         = $teamWrap.offset().top - $('.team-photo-block').offset().top + (window.innerHeight * 0.5),
            currentBlockScrollPercentage = 100 * insideBlockScrollFromTop / teamBlockFixedHeight,
            fromLeft                     = currentBlockScrollPercentage * 0.5;

      if (fromLeft < 0) {
        $('.team-photo-block__inner').css('left', 0);
      } else {
        $('.team-photo-block__inner').css('left', fromLeft + '%');
      }
    } else {
      $('.team-photo-block__inner').css('left', '50%').removeClass('fixed animated fadeIn');
    }

    if (windowBottom > $('.team-wrap-block').offset().top + $('.team-wrap-block').outerHeight()) {
      if (!$('.team-photo-block__inner').hasClass('past-team')) {
        $('.team-wrap-block').addClass('animated fadeOut');
      }
      $('.team-photo-block__inner').addClass('past-team');
    } else {
      $('.team-wrap-block').removeClass('animated fadeOut');
      $('.team-photo-block__inner').removeClass('past-team');
    }

    if (windowBottom < $teamWrap.offset().top + window.innerHeight * 0.5) {
      $teamWrap.addClass('not-initialized');
    } else {
      $teamWrap.removeClass('not-initialized');
    }
  },
  initPartnersSlider() {
    const partnersSlider = new Splide('#partners-slider', {
      type      : 'loop',
      drag      : 'free',
      perPage   : 6,
      arrows    : false,
      pagination: false,
      breakpoints: {
        1200: {
          perPage: 5,
        },
        990: {
          perPage: 3,
        },
        576: {
          perPage: 2,
        },
      },
      autoScroll: {
        speed       : 1.25,
        pauseOnHover: false,
        pauseOnFocus: false,
      },
    });

    setTimeout(function() {
      partnersSlider.mount({AutoScroll});
    }, 100);
  },
  initPortfolio() {
    $('.portfolio-navigation__link').on('click', function(e) {
      e.preventDefault();

      const filterValue = $(this).data('filter');

      $('.portfolio-navigation__item').removeClass('active');
      $(this).parent('.portfolio-navigation__item').addClass('active');
      $('.portfolio-grid__col').removeClass('fadeOut fadeIn');

      $('.portfolio-grid__col').each( function() {
        const $this = $(this);

        $this.addClass('fadeOut');

        setTimeout(function() {
          $this.addClass('d-none');

          const filters = $this.data('filter').split(',');

          if (filters.includes(filterValue) || filterValue === 'all') {
            $this.removeClass('d-none fadeOut').addClass('fadeIn');
          }
        }, 300);
      });
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js